import React, { FC } from 'react';
import { Typography } from '@mui/material';
import useAppTheme from '../hooks/useAppTheme';


const NewLabel: FC = () => {
  const theme = useAppTheme();

  return (
        <Typography
            variant="caption"
            color={theme.palette.success.dark}
            fontSize="11px"
            fontWeight="bold"
            sx={{
              px: 0.5,
              borderRadius: 0.5,
              backgroundColor: theme.palette.success.light,
            }}
        >
            New
        </Typography>
  );
};

export default NewLabel;
